<template>
    <div class="container-fluid bg-white container-fluid px-4 py-5 rounded-4 contenedor-principal">
        <div class="grid-header">
          <h1>{{$t("liquidaciones.titulo")}}</h1>
          <div class="d-flex justify-content-end gap-3 mb-3">
            <DxButton 
                v-bind="primaryButtonProps()" 
                :text="$t('liquidaciones.grid.btn_liquidar_autofactura')"
                @click="liquidarAutofactura"
            />
          </div>
        </div>
        
        <liquidaciones-grid/>
        <rappels-mensuales-grid class="mt-4"/>
    </div>
</template>

<script setup lang="ts">
import { DxButton } from "devextreme-vue/button";
import LiquidacionesGrid from "@/components/liquidaciones/LiquidacionesGrid.vue";
import RappelsMensualesGrid from "@/components/liquidaciones/RappelsMensualesGrid.vue";
import { primaryButtonProps } from "@/.shared/helpers/button-helper";
import { useRouter } from "@/.shared/services/routing-services";
import { useIntl } from "@/.shared/services/i18n/i18nservice";

const router = useRouter();
const intl = useIntl();

const liquidarAutofactura = async () => {
  await router.push(intl.i18Route({ name: "datos-factura", query: { esAutofactura: "true"}}));
}

</script>
